<template>
  <div>
    <b-modal
      v-model="isModalPagamentoOpen"
      size="xl"
      :modal-class="`${queryData.iframed ? 'modal-iframed' : ''}`"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <template #modal-header v-if="!queryData.iframed">
        <div
          class="ticketheader w-100"
          :style="`border-bottom-color:  ${bookingDetails.statusColor} ; background-color:  ${bookingDetails.statusColor} ;
                background: radial-gradient(circle 3px at bottom left,  ${bookingDetails.statusColor}  85%, ${bookingDetails.statusColor}) bottom left, radial-gradient(circle 3px at bottom right,  ${bookingDetails.statusColor}  85%, ${bookingDetails.statusColor}) bottom right;
                background-size:50% 100%; background-repeat:no-repeat;`"
        >
          <!-- close button
                <div class="text-right text-white">
                  <button @click.prevent="closePagamentoModal()" type="button" class="close pt-2" data-dismiss="modal" aria-label="Close">
                    <span @click.prevent="closePagamentoModal()" style="color: white">x</span>
                  </button>
                </div>
                  -->
          <div class="">
            <div class="iconarea">
              <div class="ticketicon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2984_25576)">
                    <path
                      d="M28.6667 29.3346H3.33333C1.496 29.3346 0 27.8386 0 26.0013V23.3346C0 22.9666 0.298667 22.668 0.666667 22.668H1.33333C2.804 22.668 4 21.472 4 20.0013C4 18.5306 2.804 17.3346 1.33333 17.3346H0.666667C0.298667 17.3346 0 17.036 0 16.668V14.0013C0 12.164 1.496 10.668 3.33333 10.668H28.6667C30.504 10.668 32 12.164 32 14.0013V16.668C32 17.036 31.7013 17.3346 31.3333 17.3346H30.6667C29.196 17.3346 28 18.5306 28 20.0013C28 20.7133 28.2773 21.3826 28.7813 21.8866C29.284 22.3906 29.9533 22.668 30.6653 22.668H31.332C31.7 22.668 31.9987 22.9666 31.9987 23.3346V26.0013C32 27.8386 30.504 29.3346 28.6667 29.3346ZM1.33333 24.0013V26.0013C1.33333 27.104 2.23067 28.0013 3.33333 28.0013H28.6667C29.7693 28.0013 30.6667 27.104 30.6667 26.0013V24.0013C29.5987 24.0013 28.5933 23.5853 27.8387 22.8306C27.0827 22.0746 26.6667 21.0693 26.6667 20.0013C26.6667 17.796 28.4613 16.0013 30.6667 16.0013V14.0013C30.6667 12.8986 29.7693 12.0013 28.6667 12.0013H3.33333C2.23067 12.0013 1.33333 12.8986 1.33333 14.0013V16.0013C3.53867 16.0013 5.33333 17.796 5.33333 20.0013C5.33333 22.2066 3.53867 24.0013 1.33333 24.0013Z"
                      fill="white"
                    />
                    <path
                      d="M11.3334 13.3346C10.9654 13.3346 10.6667 13.036 10.6667 12.668V11.3346C10.6667 10.9666 10.9654 10.668 11.3334 10.668C11.7014 10.668 12.0001 10.9666 12.0001 11.3346V12.668C12.0001 13.036 11.7014 13.3346 11.3334 13.3346Z"
                      fill="white"
                    />
                    <path
                      d="M11.3334 24.6161C10.9654 24.6161 10.6667 24.3174 10.6667 23.9494V21.6947C10.6667 21.3267 10.9654 21.0281 11.3334 21.0281C11.7014 21.0281 12.0001 21.3254 12.0001 21.6947V23.9507C12.0001 24.3187 11.7014 24.6161 11.3334 24.6161ZM11.3334 18.9761C10.9654 18.9761 10.6667 18.6774 10.6667 18.3094V16.0534C10.6667 15.6854 10.9654 15.3867 11.3334 15.3867C11.7014 15.3867 12.0001 15.6854 12.0001 16.0534V18.3094C12.0001 18.6774 11.7014 18.9761 11.3334 18.9761Z"
                      fill="white"
                    />
                    <path
                      d="M11.3334 29.3346C10.9654 29.3346 10.6667 29.036 10.6667 28.668V27.3346C10.6667 26.9666 10.9654 26.668 11.3334 26.668C11.7014 26.668 12.0001 26.9666 12.0001 27.3346V28.668C12.0001 29.036 11.7014 29.3346 11.3334 29.3346Z"
                      fill="white"
                    />
                    <path
                      d="M3.3334 11.9991C3.06273 11.9991 2.80806 11.8338 2.7094 11.5658C2.58006 11.2205 2.75473 10.8365 3.10006 10.7085L24.3001 2.79245C25.3307 2.40579 26.5414 2.98445 26.8934 4.02312L29.2974 11.1178C29.4147 11.4671 29.2281 11.8445 28.8801 11.9631C28.5347 12.0818 28.1534 11.8938 28.0347 11.5458L25.6307 4.45112C25.5134 4.10445 25.1107 3.91512 24.7654 4.04045L3.5654 11.9565C3.4894 11.9858 3.41073 11.9991 3.3334 11.9991Z"
                      fill="white"
                    />
                  </g>

                  <defs>
                    <clipPath id="clip0_2984_25576">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <div class="reservation-code align-items-center">
                <div
                  style="color: black; font-weight: 600; font-size: large"
                  class="text-white"
                >
                  {{ '#' + bookingDetails.payload.booking_code }}
                </div>
                <div
                  class="text-gray mt-0 ml-2"
                  style="font-size: small; line-height: 100%"
                ></div>
              </div>
            </div>
          </div>
          <div class="statuscontent">
            <div class="reservation-status-info">
              <span class="text-black d-flex text-white pr-4">
                Detalhar pagamento recebido no local
              </span>
            </div>
          </div>
        </div>
      </template>
      <b-container>
        <b-card-body class="p-0">
          <b-row align-v="end">
            <b-col cols="12">
              <div class="pt-0 pb-1 text-center">
                <h2>
                  {{ bookingDetails.payload.product.place }} -
                  {{ bookingDetails.payload.product.name }}
                </h2>
              </div>
            </b-col>
          </b-row>

          <b-row align-v="end">
            <b-col cols="12">
              <div class="pb-5 text-center">
                <span>{{
                  formattedDate +
                  (', ' + bookingDetails.time)
                    .replace(':', 'h')
                    .replace('00', '')
                    .replace(' 0', ' ')
                }}</span>
              </div>
            </b-col>
          </b-row>

          <b-row align-v="end">
            <b-col v-if="!queryData.iframed" cols="3">
              <div class="pt-0">
                <span>Reserva</span>
              </div>
            </b-col>

            <b-col cols="9">
              <div class="pt-0">
                <span>{{ bookingDetails.booking_name }}</span>
              </div>
            </b-col>
          </b-row>

          <hr class="pt-0" />

          <b-row align-v="start">
            <b-col v-if="!queryData.iframed" cols="3">
              <div class="pt-0">
                <span>Responsável</span>
              </div>
            </b-col>

            <b-col>
              <span>{{ bookingDetails.name }}</span>
              <br />
              <span>{{ bookingDetails.phone }}</span>
            </b-col>
          </b-row>
          <hr />

          <b-row align-v="start">
            <b-col v-if="!queryData.iframed" cols="3" cols-sm="12">
              <div class="pt-0">
                <span>Ingressos</span>
              </div>
            </b-col>

            <b-col cols="9" cols-sm="12">
              <div v-for="(ticket, idx) in tickets" :key="idx">
                <span v-if="ticket.quantity > 0">
                  {{ ticket.name }}
                  {{
                    ' (' +
                    ticket.quantity +
                    ' x ' +
                    ticket.price.toFixed(2).replace('.', ',') +
                    ')' +
                    ': R$' +
                    (ticket.price * ticket.quantity)
                      .toFixed(2)
                      .replace('.', ',')
                  }}
                </span>
              </div>

              <div align-h="end">
                <b>
                  Total:
                  {{
                    new Number(totalCost).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  }}
                </b>
              </div>
            </b-col>
          </b-row>
          <hr />
          <template>
            <b-row align-v="start">
              <b-col cols="3">
                <div class="pt-4 pb-2">
                  <b>Pagamentos</b>
                </div>
              </b-col>

              <b-col cols="12">
                <div align-h="end">
                  <LocalPaymentMethods
                    :ticketPrice="totalCost"
                    @update="setLocalPayments($event)"
                    @validation="setIsLocalPaymentsValid($event)"
                  />
                </div>
              </b-col>
            </b-row>
          </template>
        </b-card-body>
      </b-container>
      <template #modal-footer>
        <div class="floating-nav d-flex">
          <b-button variant="secondary" @click="closePagamentoModal"
            >Voltar</b-button
          >
          <b-button
            variant="primary"
            :disabled="!isLocalPaymentsValid"
            @click="confirmLocalPayment"
            >Confirmar</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import LocalPaymentMethods from './LocalPaymentMethods.vue'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { isMobile } from '@/store/utils/general'
import swal from 'sweetalert2'
import qrcodeVue from 'qrcode.vue'
import PagamentoModal from './PagamentoModal.vue'
import useManageReservaExpressa from '../../Composables/useManageReservaExpressa'

export default {
  component: 'PagamentoResumo',

  components: {
    PagamentoModal,
    qrcodeVue,
    LocalPaymentMethods,
  },

  setup(props, context) {
    const manageReservaExpressa = useManageReservaExpressa(context)

    function calculateTotalCost() {
      return manageReservaExpressa.calculateTotalCost()
    }
    function setTickets(items) {
      return manageReservaExpressa.setTickets(items)
    }

    return {
      calculateTotalCost,
      setTickets,
    }
  },

  props: {
    isModalPagamentoOpen: {
      type: Boolean,
      default: true,
    },

    PAYMENT_STATUS: {
      type: String,
      default: '' | null,
    },

    isPaymentLater: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localPayments: [],
      isLocalPaymentsValid: false,
      queryData: {},
    }
  },

  watch: {
    ['form.tickets'](newValue, oldValue) {
      this.setTickets(newValue)
    },
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
    }),

    ...mapGetters('operacao', {
      bookingFromRoute: 'getBookingDetails',
    }),

    tickets() {
      var vm = this
      return Object.values(this.bookingDetails.tickets)
        .map(function (val, idx) {
          var quantity = Number(val.quantity)
          var price = val.price || val.unit_price || 0
          if (typeof price === 'string') {
            price = parseFloat(price.replace(/[^0-9.]/g, '.'))
          }
          if (quantity > 0) {
            return {
              name:
                val.label != null &&
                val.label != undefined &&
                val.label.length > 0
                  ? val.label
                  : val.booking_name,
              description: vm.bookingDetails.booking_name + '-' + val.label,
              price: Number(price.toFixed(2)),
              quantity: parseInt(val.quantity),
              sku: '',
            }
          }
        })
        .filter((i) => i != undefined)
    },

    disabledButton() {
      return this.bookingDetails.name.length == 0 ||
        this.bookingDetails.name.length < 2 ||
        this.bookingDetails.phone.length == 0 ||
        this.bookingDetails.phone.length < 14
        ? true
        : false
    },

    totalCost() {
      return this.calculateTotalCost()
    },

    //TODO use utils.general.formatDate
    formattedDate() {
      return moment(this.bookingDetails.date).format('DD/MM/YY')
    },

    bookingDetails() {
      if (
        !this.isPaymentLater &&
        this.bookingFromRoute.length > 0 &&
        this.bookingFromRoute[0]
      ) {
        return {
          ...this.form,
          statusColor: this.bookingFromRoute[0].statusColor,
          booking_name: this.bookingFromRoute[0].payload.booking_name,
          name: this.bookingFromRoute[0].payload.costumer.name,
          phone: this.bookingFromRoute[0].payload.costumer.phone.number,
          tickets: this.bookingFromRoute[0].payload.items,
          payload: this.bookingFromRoute[0].payload,
        }
        return this.bookingFromRoute[0]
      } else if (this.form) {
        let payload = {
          booking_code: 'NOVA',
          product: {
            place: this.form.atrativo.vendor_name || 'gestor',
            name: this.form.atrativo.product_name,
          },
        }
        return {
          ...this.form,
          statusColor: 'rgb(34, 123, 160)',
          payload: payload,
        }
      }
      return null
    },
  },

  methods: {
    ...mapActions('booking', ['createExpressBooking', 'bookingStoreCommit']),

    setIsLocalPaymentsValid(value) {
      this.isLocalPaymentsValid = value
    },
    setLocalPayments(payments) {
      this.localPayments = payments
    },

    closePagamentoModal() {
      this.$emit('closePagamentoModal')
    },

    confirmLocalPayment() {
      this.$emit('confirmLocalPayment', this.localPayments)
    },

    prev() {
      this.$emit('goToSection', 'dados')
    },
  },

  mounted() {
    if (
      process.env.NODE_ENV !== 'production' ||
      this.$route.query.debug == 'true'
    ) {
      window.jdebug = this
    }
    this.setTickets(this.tickets)
    try {
      this.queryData = JSON.parse(atob(Object.keys(this.$route.query)[0]))
    } catch (e) {}
  },
}
</script>

<style scoped>
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.floating-nav {
  min-width: 250px;
  height: auto;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px 12px 0 0px;
  padding: 15px;
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 50%;
  justify-content: space-between;
  transform: translateX(-50%);
}

@media screen and (max-width: 870px) {
  .floating-nav {
    width: 100%;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    padding: 15px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    left: 50%;
    justify-content: space-between;
    transform: translateX(-50%);
  }
}
</style>
